// Lightweight language/locale helpers shared by both the React i18n provider
// and pure library helpers (e.g. time.js) that cannot use React context.

import { logWarn, ignore } from "@/lib/log";

export const LANGS = ["en", "fi", "sv"];
export const LOCALE_MAP = { en: "en-GB", fi: "fi-FI", sv: "sv-SE" };
export const STORAGE_KEY = "chronicles.lang";

export function getStoredLang() {
  try {
    const v = localStorage.getItem(STORAGE_KEY);
    if (v && LANGS.includes(v)) return v;
  } catch {
    ignore();
  }
  return "en";
}

export function setStoredLang(lang) {
  try {
    localStorage.setItem(STORAGE_KEY, lang);
    window.dispatchEvent(new CustomEvent("chronicles:settings-changed"));
  } catch (e) {
    logWarn("could not persist language preference.", e);
  }
}

export function getLocale() {
  return LOCALE_MAP[getStoredLang()] || "en-GB";
}
